/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClientInvestmentProfile } from './ClientInvestmentProfile';
import {
    ClientInvestmentProfileFromJSON,
    ClientInvestmentProfileFromJSONTyped,
    ClientInvestmentProfileToJSON,
    ClientInvestmentProfileToJSONTyped,
} from './ClientInvestmentProfile';
import type { ClientType } from './ClientType';
import {
    ClientTypeFromJSON,
    ClientTypeFromJSONTyped,
    ClientTypeToJSON,
    ClientTypeToJSONTyped,
} from './ClientType';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { BookingCenter } from './BookingCenter';
import {
    BookingCenterFromJSON,
    BookingCenterFromJSONTyped,
    BookingCenterToJSON,
    BookingCenterToJSONTyped,
} from './BookingCenter';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';
import type { LanguageEnum } from './LanguageEnum';
import {
    LanguageEnumFromJSON,
    LanguageEnumFromJSONTyped,
    LanguageEnumToJSON,
    LanguageEnumToJSONTyped,
} from './LanguageEnum';

/**
 * 
 * @export
 * @interface Offering
 */
export interface Offering {
    /**
     * This field has to be `null` on the request, since temporary offerings are created not updated
     * @type {string}
     * @memberof Offering
     */
    offeringId?: string;
    /**
     * 
     * @type {LanguageEnum}
     * @memberof Offering
     */
    language: LanguageEnum;
    /**
     * 
     * @type {CountryCode}
     * @memberof Offering
     */
    clientDomicile: CountryCode;
    /**
     * 
     * @type {boolean}
     * @memberof Offering
     */
    isUkResident?: boolean;
    /**
     * 
     * @type {BookingCenter}
     * @memberof Offering
     */
    bookingCenter: BookingCenter;
    /**
     * 
     * @type {ClientInvestmentProfile}
     * @memberof Offering
     */
    clientInvestmentProfile: ClientInvestmentProfile;
    /**
     * 
     * @type {ClientType}
     * @memberof Offering
     */
    clientType: ClientType;
    /**
     * 
     * @type {BookingCenter}
     * @memberof Offering
     */
    pmLocation: BookingCenter;
    /**
     * 
     * @type {Currency}
     * @memberof Offering
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof Offering
     */
    investmentAmount: number;
}



/**
 * Check if a given object implements the Offering interface.
 */
export function instanceOfOffering(value: object): value is Offering {
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('clientDomicile' in value) || value['clientDomicile'] === undefined) return false;
    if (!('bookingCenter' in value) || value['bookingCenter'] === undefined) return false;
    if (!('clientInvestmentProfile' in value) || value['clientInvestmentProfile'] === undefined) return false;
    if (!('clientType' in value) || value['clientType'] === undefined) return false;
    if (!('pmLocation' in value) || value['pmLocation'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('investmentAmount' in value) || value['investmentAmount'] === undefined) return false;
    return true;
}

export function OfferingFromJSON(json: any): Offering {
    return OfferingFromJSONTyped(json, false);
}

export function OfferingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Offering {
    if (json == null) {
        return json;
    }
    return {
        
        'offeringId': json['offeringId'] == null ? undefined : json['offeringId'],
        'language': LanguageEnumFromJSON(json['language']),
        'clientDomicile': CountryCodeFromJSON(json['clientDomicile']),
        'isUkResident': json['isUkResident'] == null ? undefined : json['isUkResident'],
        'bookingCenter': BookingCenterFromJSON(json['bookingCenter']),
        'clientInvestmentProfile': ClientInvestmentProfileFromJSON(json['clientInvestmentProfile']),
        'clientType': ClientTypeFromJSON(json['clientType']),
        'pmLocation': BookingCenterFromJSON(json['pmLocation']),
        'currency': CurrencyFromJSON(json['currency']),
        'investmentAmount': json['investmentAmount'],
    };
}

export function OfferingToJSON(json: any): Offering {
    return OfferingToJSONTyped(json, false);
}

export function OfferingToJSONTyped(value?: Offering | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offeringId': value['offeringId'],
        'language': LanguageEnumToJSON(value['language']),
        'clientDomicile': CountryCodeToJSON(value['clientDomicile']),
        'isUkResident': value['isUkResident'],
        'bookingCenter': BookingCenterToJSON(value['bookingCenter']),
        'clientInvestmentProfile': ClientInvestmentProfileToJSON(value['clientInvestmentProfile']),
        'clientType': ClientTypeToJSON(value['clientType']),
        'pmLocation': BookingCenterToJSON(value['pmLocation']),
        'currency': CurrencyToJSON(value['currency']),
        'investmentAmount': value['investmentAmount'],
    };
}

